import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Overline, Reveal } from "./Shared";

const FAQS = [
  {
    q: "What happens after I submit the form?",
    a: "Your inquiry is securely recorded and reviewed against active matters in your state. If it matches an active review, an independent legal intake coordinator or attorney may contact you by phone or email. There is no obligation to proceed.",
  },
  {
    q: "Does it cost anything to submit?",
    a: "No. Requesting a case review through this page is free and comes with no obligation. Many attorneys who handle these matters work on a contingency basis — meaning their fee depends on the outcome — but any fee arrangement is between you and the attorney you choose.",
  },
  {
    q: "What is the difference between a mass tort and a class action?",
    a: "In a class action, one case represents a large group with an identical claim. In a mass tort, each person's case remains individual — your specific injuries and circumstances are considered separately, even though many cases involve the same product or exposure.",
  },
  {
    q: "How long do I have to file a claim?",
    a: "Every state sets its own deadlines (statutes of limitations), and they vary by case type. Some windows are short. That is why it is sensible to request a review promptly rather than assume you have time.",
  },
  {
    q: "I was diagnosed with mesothelioma. What matters most?",
    a: "Mesothelioma typically appears 20 to 60 years after asbestos exposure, so claims often trace back to work done decades ago — shipyards, construction, power plants, military service (especially the Navy), or even secondary exposure from a family member's work clothing. A confirmed diagnosis, your work or service history, and any records of the products you were exposed to are the foundations of a review. Asbestos trust funds also operate on their own timelines.",
  },
  {
    q: "Does submitting this form make you my lawyer?",
    a: "No. Lawsuit Settlement Help is a consumer intake service, not a law firm. Submitting this form does not create an attorney-client relationship. That relationship only begins if you later sign a representation agreement with an attorney.",
  },
];

const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="border-b border-[#E7E2DA] py-20 sm:py-28 scroll-mt-20"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-10 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <Overline>Chapter 06 — Questions</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-[#1A1715] leading-tight">
            Asked often, answered honestly.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-[#E7E2DA]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-serif font-semibold text-lg sm:text-xl text-[#1A1715] hover:text-[#C2410C] hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="pb-6 font-news text-base text-[#44403C] leading-relaxed"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
